<template>
  <DialogTemplate
    :show-controls="true"
    class="dialog-share"
    v-bind="$attrs"
    @close="emit('close')"
  >
    <template #header>{{ title }}</template>
    <render />
    <ButtonBase
      v-if="isCopySupported && !isShareSupported"
      class="button"
      stroke="n"
      theme="secondary"
      size="small"
      variant="outlined"
      rounded
      :disabled="copied"
      @click="handleCopy"
    >
      {{ labelCopyButton }}
    </ButtonBase>
    <ButtonBase
      v-if="isShareSupported"
      class="button"
      stroke="n"
      size="small"
      theme="secondary"
      rounded
      :disabled="copied"
      @click="handleClickShare"
    >
      Partager
    </ButtonBase>
  </DialogTemplate>
</template>
<script lang="ts" setup>
import DialogShareText from './DialogShareText.vue';
interface Props {
  title: string;
  label: string;
  iconHeader?: string | null;
  closeTimer?: number;
  closeClickOutside?: boolean;
  position?: 'center' | 'top-right';
  shareText: string;
  viewShareAvailable?: { component: Component; props: any };
  viewShareIsNotAvailable?: { component: Component; props: any };
}

const props = defineProps({
  title: null,
  label: null,
  iconHeader: null,
  closeTimer: null,
  closeClickOutside: { type: Boolean, default: true },
  position: { default: 'center' },
  shareText: null,
  viewShareAvailable: null,
  viewShareIsNotAvailable: null
});

const emit = defineEmits(["close"]);

const { share, isSupported: isShareSupported } = useShare();

const {
  copy,
  copied,
  isSupported: isCopySupported,
} = useClipboard({ source: props.shareText });

const dialog = useDialogStore();

const labelCopyButton = computed(() =>
  copied.value ? 'Copié' : 'Copier le texte'
);

const handleCopy = () => {
  copy(props.shareText);
};

const handleClickShare = (e) => {
  share({
    text: props.shareText,
  });
  e.preventDefault();
};

const { start: startTiemoutClose } = useTimeoutFn(
  () => {
    dialog.close();
    emit('close');
  },
  1000,
  { immediate: false }
);

watch(
  () => copied.value,
  (b) => {
    if (b) startTiemoutClose();
  }
);

const render = () => {
  const children = [];
  if (isShareSupported.value) {
    if (props.viewShareAvailable) children.push(props.viewShareAvailable);
  } else if (props.viewShareIsNotAvailable) {
    if (props.viewShareIsNotAvailable)
      children.push(props.viewShareIsNotAvailable);
    children.push({
      component: DialogShareText,
      props: { text: props.shareText },
    });
  } else {
    children.push({
      component: DialogShareText,
      props: { text: props.shareText },
    });
  }
  return children.map((child) => h(child.component, { ...child.props }));
};
</script>
<style lang="scss" scoped>
.dialog-share {
  @include above('s') {
    max-width: 40rem;
    overflow-y: auto;
    &.top-right {
      align-self: start;
      justify-self: end;
    }
  }
}
.button {
  width: 100%;
}
.banner {
  width: 100%;
}
</style>
